export default function getBrowserWindow(): any {
    return window as any;
}
